// eslint-disable-next-line max-classes-per-file
import { IActivityConfiguration } from 'app/authoring/interfaces/IActivityComponent';
import { Metamodel } from 'app/model/base/model';
import { ActivityConfigurations } from 'app/authoring/registries/activity-configurations';
import {
    InvokeADFPipelineActivity,
    AzureBlobStorageActivity,
    AzureDevOpsActivity,
    EmailActivity,
    ExtensibleActivity,
    TeamsActivity
} from 'app/model/pipeline/extensible.activity';
import { ModelService } from 'app/model/services/model.service';
import { IResourceContext } from 'shell-models-lib';

export class ExtensibleActivityConfiguration implements IActivityConfiguration {
    public label = stringResources.ExtensibleActivityLabel;
    public name = 'Extensible';
    public activityType = Metamodel.modelFor(ExtensibleActivity);
    public iconClass = 'svg-i_Mail_16x16';
    public iconTransform = '';
    public categories = [stringResources.Notifications];

    public supportedInTrident = true;

    public async preSave(contextData: IResourceContext, model: ExtensibleActivity, modelService: ModelService): Promise<boolean> {
        if (model.credential?.name) {
            await modelService.fetch(model.credential);
        }
        return true;
    }
}

@ActivityConfigurations.register({})
export class EmailActivityConfiguration extends ExtensibleActivityConfiguration {
    public label = stringResources.EmailActivityLabel;
    public name = 'Office 365 Outlook';
    public activityType = Metamodel.modelFor(EmailActivity);
    public iconClass = 'svg-i_Mail_16x16';
    public isKnownInPipelineContext = true;
}

@ActivityConfigurations.register({})
export class TeamsActivityConfiguration extends ExtensibleActivityConfiguration {
    public label = stringResources.TeamsActivityLabel;
    public name = 'Teams';
    public activityType = Metamodel.modelFor(TeamsActivity);
    public iconClass = 'svg-i_Teams_16x16';
    public isKnownInPipelineContext = true;
}

@ActivityConfigurations.register({})
export class AzureBlobStorageActivityConfiguration extends ExtensibleActivityConfiguration {
    public label = stringResources.AzureBlobStorage_DisplayText;
    public name = 'Azure Blob Storage';
    public activityType = Metamodel.modelFor(AzureBlobStorageActivity);
    public iconClass = 'svg-i-20x20-AzureBlob';
    public categories = [stringResources.General]; //category TBD, put it in General for now
}

@ActivityConfigurations.register({})
export class AzureDevOpsActivityConfiguration extends ExtensibleActivityConfiguration {
    public label = stringResources.AzureDevopsActivityLabel;
    public name = 'Azure DevOps actions';
    public activityType = Metamodel.modelFor(AzureDevOpsActivity);
    public iconClass = 'svg-i-20x20-Azure-DevOps';
    public categories = [stringResources.General]; //category TBD, put it in General for now
}

@ActivityConfigurations.register({})
export class InvokeADFPipelineActivityConfiguration extends ExtensibleActivityConfiguration {
    public label = stringResources.InvokeADFPipelineActivityLabel;
    public name = 'Invoke ADF pipeline';
    public activityType = Metamodel.modelFor(InvokeADFPipelineActivity);
    public iconClass = 'svg-i-20x20-adf';
    public categories = [stringResources.General]; //category TBD, put it in General for now
}
